import { render, staticRenderFns } from "./PurchaseInModal.vue?vue&type=template&id=317470a3&scoped=true"
import script from "./PurchaseInModal.vue?vue&type=script&lang=js"
export * from "./PurchaseInModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317470a3",
  null
  
)

export default component.exports